import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { patchRequest } from "../../../../utils/requests";
import FieldMsg from "./fieldMsg";
import useSessionStore from "../../../../stores/useSessionStore";

const DateField = props => {
  const [content, setContent] = useState(
    props.value ? new Date(props.value) : null
  );
  const [saved, setSaved] = useState(false);
  const [msg, setMsg] = useState("");

  const selApp = useSessionStore(state => state.selApp);

  useEffect(() => {
    if (saved) {
      setMsg("Saved to draft");
    }
  }, [saved]);

  const autoSave = async newVal => {
    const fieldcontentid = props.dataId;

    let timestamp = null;

    try {
      timestamp = new Date(newVal).toUTCString();
    } catch (err) {
      setMsg("Invalid Datetime!");
      return false;
    }

    const req = await patchRequest(
      "/api/panel/apps/" + selApp + "/content/" + props.contentUuid,
      { [fieldcontentid]: timestamp }
    );

    if (req.error) {
      setMsg(req.error);
      props.drafting(false);
      props.disablePublish(true);
    } else {
      props.drafting(false);
      props.disablePublish(false);
      props.updateEditedTime(req.editedAt);
      setSaved(true);
    }
  };

  const handleChange = date => {
    setContent(date);
    setSaved(false);

    setMsg("saving...");
    props.disablePublish(false);
    props.drafting(true);
    autoSave(date);
  };

  useEffect(() => {
    if (props.contentStatus === "published") {
      setMsg("");
    }
  }, [props.contentStatus]);

  useEffect(() => {
    if (props.isDraftDiscarded) {
      setContent(props.value);
      setMsg("");
    }
  }, [props.isDraftDiscarded, props.value]);

  return (
    <div style={{ marginBottom: "10px", marginTop: "30px" }}>
      <div className="datepicker">
        <h4 style={{ marginBottom: "5px" }}>{props.label}</h4>
        <label htmlFor="datepicker">
          <i
            className="material-icons hoverblue"
            style={{ marginRight: "10px" }}
          >
            calendar_today
          </i>
        </label>
        <DatePicker
          id="datepicker"
          selected={content}
          showTimeSelect
          onChange={date => {
            handleChange(date);
            setMsg("");
          }}
          dateFormat="M/d/yyyy h:mm aa"
          timeIntervals={props.fieldOptions.timeIntervals || 1}
        />

        <FieldMsg msg={msg} />
      </div>
    </div>
  );
};

export default DateField;
